import { gql } from "@apollo/client";

export const GET_ATTENDANCE_FORM_DATA = gql`
  query AttendanceFormData($eventId: String, $eventIdHash: String) {
    attendanceFormData(eventId: $eventId, eventIdHash: $eventIdHash) {
      sessionDetails {
        sessionId
        sessionName
        programmeId
        externalSessionId
        programmeName
        activityName
        startDate
        endDate
        location
        venue
        activityId
        activityType
        startDateTimeDisplay
        surveyId
      }
      validationErrors {
        errorMessage
        errorCode
      }
      messages
      hasError
    }
  }
`;
